import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { Button, IconButton, Stack, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { AppContainer } from '../../ui-kit/AppContainer';
import { BoxHeaderLogo, BoxHeaderNav, CardHeader, ContainerHeader } from './style';
import { routesProfile } from '../../../consts';
import { NavLink } from 'react-router-dom';
import { PureLightTheme } from '../../../styles/theme';
import { UserAccountMenu } from '../UserAccountMenu';
import { EventsMenu } from '../EventsMenu';
import { IconLogo } from '../../../icons/IconLogo';
import { useProfileGate } from '../../../hooks/useProfileGate';
import { revokeToken } from '../../../utils/api';
import { cleanupWebPushSubscription } from '../../../utils/webPush';
import { useAppDispatch } from '../../../hooks';
import { routesGuest } from '../../../consts';
import {
    dictionariesApi,
    growthToolsApi,
    notificationsApi,
    platformReportsApi,
    profileApi,
    projectsApi,
    recommendationsApi,
    socialOrdersApi,
    teamsApi,
    usersApi,
} from '../../../api';
import { RecommendationsNavBadge } from '../RecommendationsNavBadge';
import { RecommendationRoundedIcon } from '../../../icons/RecommendationRoundedIcon';

export const PHeader = () => {
    const isTablet = useMediaQuery(PureLightTheme.breakpoints.down('md'));
    const { isProfileReady, isProfileComplete } = useProfileGate();
    const hasIncompleteProfile = isProfileReady && !isProfileComplete;
    const dispatch = useAppDispatch();

    const handleLogout = async () => {
        try {
            await cleanupWebPushSubscription();
        } catch {
            // best effort
        }
        await revokeToken();

        dispatch(profileApi.util.resetApiState());
        dispatch(dictionariesApi.util.resetApiState());
        dispatch(usersApi.util.resetApiState());
        dispatch(projectsApi.util.resetApiState());
        dispatch(teamsApi.util.resetApiState());
        dispatch(growthToolsApi.util.resetApiState());
        dispatch(socialOrdersApi.util.resetApiState());
        dispatch(notificationsApi.util.resetApiState());
        dispatch(platformReportsApi.util.resetApiState());
        dispatch(recommendationsApi.util.resetApiState());

        window.location.assign(routesGuest.ROOT.path);
    };

    return (
        <AppBar position="fixed" sx={CardHeader }>
            <AppContainer sx={ContainerHeader}>
                <Box sx={ BoxHeaderLogo }>
                    <NavLink to={`../${routesProfile.ROOT.path}`}>
                        <IconLogo />
                    </NavLink>
                </Box>

                {!isTablet && !hasIncompleteProfile && (
                    <Box sx={BoxHeaderNav}>
                        <NavLink to={`/${routesProfile.PROJECTS.path}`} className="headerNavLink">
                            <Typography variant='typHeader'>Проекты</Typography>
                        </NavLink>
                        <NavLink to={`/${routesProfile.SOCIALORDERS.path}`} className="headerNavLink">
                            <Typography variant='typHeader'>Соц-заказы</Typography>
                        </NavLink>
                        <NavLink to={`/${routesProfile.USERS.path}`} className="headerNavLink">
                            <Typography variant='typHeader'>Люди</Typography>
                        </NavLink>
                        <NavLink to={`/${routesProfile.TEAMS.path}`} className="headerNavLink">
                            <Typography variant='typHeader'>Команды</Typography>
                        </NavLink>
                        <NavLink to={`/${routesProfile.GROWTHTOOLS.path}`} className="headerNavLink">
                            <Typography variant='typHeader'>Инструменты роста</Typography>
                        </NavLink>
                    </Box>
                )}
                
                <Stack direction="row" gap={1} alignItems="center">
                    {isTablet && !hasIncompleteProfile && (
                        <>
                            <EventsMenu />
                            <Tooltip title="Рекомендации" arrow>
                                <IconButton
                                    component={NavLink}
                                    to={`/${routesProfile.RECOMMENDATIONS.path}`}
                                    sx={{ padding: 0.5 }}
                                >
                                    <RecommendationsNavBadge>
                                        <RecommendationRoundedIcon fontSize="medium" />
                                    </RecommendationsNavBadge>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                    {hasIncompleteProfile ? (
                        <Button variant="follow" onClick={handleLogout}>Выйти</Button>
                    ) : (
                        <UserAccountMenu isTablet={isTablet} />
                    )}
                </Stack>
            </AppContainer>
        </AppBar>
    );
}
